import i18n from '@/locales/index'
class TitleWink {
  originTitle = ''
  newTitle = ''
  timer = null
  times = 1
  delay = 2000

  setTitle() {
    document.title = this.times % 2 === 0 ? this.originTitle : this.newTitle

    this.times++

    if (this.times > 6) {
      this.delay = 5000
    }

    this.timer = setTimeout(this.setTitle.bind(this), this.delay)
  }

  init(total, text = i18n.t('utils_title_wink_2424')) {
    if (!this.originTitle) {
      this.originTitle = document.title
    }
    this.newTitle = `(${total})${text}`
    this.reset()

    this.setTitle()
  }

  reset() {
    clearTimeout(this.timer)
    document.title = this.originTitle
    this.timer = null
    this.times = 1
    this.delay = 2000
  }

  clear() {
    this.reset()
    this.newTitle = ''
  }
}

export default TitleWink